import _styled from "@emotion/styled-base";
import { remRhythm } from "../css";

var ComboboxMessage = /*#__PURE__*/_styled("p", {
  target: "eq1wzd40"
})("label:base;margin:0;padding:", remRhythm(1 / 8), " ", remRhythm(3 / 8), ";");

ComboboxMessage.displayName = "ComboboxMessage";
export default ComboboxMessage;